import { useState, useEffect } from "react";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Tab, Box, useMediaQuery, useTheme } from "@mui/material";
import GlobalMessaging from "./messaging/GlobalMessaging";
import UserMessaging from "./messaging/UserMessaging";
import ConversationsList from "./messaging/ConversationsList";
import ConversationView from "./messaging/ConversationView";

const Messaging = ({
  messageRecipient,
  conversationToView,
  onClearRecipient,
  onClearConversationToView,
}) => {
  const [activeTab, setActiveTab] = useState("conversations");
  const [selectedConversationId, setSelectedConversationId] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // Switch to user tab and set recipient when messageRecipient is provided
  useEffect(() => {
    if (messageRecipient) {
      setActiveTab("user");
    }
  }, [messageRecipient]);

  // Switch to conversations tab and select conversation when conversationToView is provided
  useEffect(() => {
    if (conversationToView) {
      setActiveTab("conversations");
      setSelectedConversationId(conversationToView);
      if (onClearConversationToView) {
        onClearConversationToView();
      }
    }
  }, [conversationToView, onClearConversationToView]);

  const handleSelectConversation = (conversationId) => {
    setSelectedConversationId(conversationId);
  };

  const handleMessageSent = (userId) => {
    setActiveTab("conversations");
    setSelectedConversationId(userId);
  };

  return (
    <div className="messaging">
      <TabContext value={activeTab}>
        <TabList onChange={(e, newValue) => setActiveTab(newValue)}>
          <Tab label="Conversations" value="conversations" />
          <Tab label="Global" value="global" />
          <Tab label="New User Message" value="user" />
        </TabList>
        <TabPanel value="conversations" sx={{ p: 0, pt: 2 }}>
          {isMobile ? (
            // Mobile: Show either list or conversation view
            selectedConversationId ? (
              <ConversationView
                conversationId={selectedConversationId}
                onBack={() => setSelectedConversationId(null)}
              />
            ) : (
              <ConversationsList
                onSelectConversation={handleSelectConversation}
                selectedConversationId={selectedConversationId}
              />
            )
          ) : (
            // Desktop: Split view
            <Box sx={{ display: "flex", gap: 2, height: "700px" }}>
              <Box
                sx={{
                  width: { sm: "300px", md: "350px", lg: "400px", xl: "450px" },
                  flexShrink: 0,
                  border: "1px solid",
                  borderColor: "divider",
                  borderRadius: 2,
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                }}
              >
                <ConversationsList
                  onSelectConversation={handleSelectConversation}
                  selectedConversationId={selectedConversationId}
                />
              </Box>
              <Box
                sx={{
                  flex: 1,
                  border: "1px solid",
                  borderColor: "divider",
                  borderRadius: 2,
                  overflow: "hidden",
                }}
              >
                <ConversationView conversationId={selectedConversationId} />
              </Box>
            </Box>
          )}
        </TabPanel>
        <TabPanel value="global">
          <GlobalMessaging />
        </TabPanel>
        <TabPanel value="user">
          <UserMessaging
            messageRecipient={messageRecipient}
            onClearRecipient={onClearRecipient}
            onMessageSent={handleMessageSent}
          />
        </TabPanel>
      </TabContext>
    </div>
  );
};

export default Messaging;
